module.exports = __webpack_public_path__ + "static/media/preview_difficulty.848ed1a4.svg";